import { Component } from 'react'
import check from "../../assets/check.svg";
import checkGreen from "../../assets/check.png";
import Cookies from 'js-cookie';

import eliminar from "../../assets/eliminar.svg";
import subaacfe from "../../assets/subiracuerdoFE.svg";
import subaacfm from "../../assets/subiracuerdoFM.svg";
import subirdoc from "../../assets/Subir.svg"
import rostoimglegacy from "../../assets/FotoPERSONAL.svg";
import rostoimg from "../../assets/fotoRostro.svg";
import camaraNecesaria from "../../assets/CAMARAnecesariaSilver.svg"
import subir from "../../assets/subircedula.svg"
import cedimg from "../../assets/FotoCEDULA.svg"
import Modal from './Modal';
import ModalXL from './ModalXL';
import axios from "axios";
import "../../css/Acuerdo.css"
import Header from './Header.js'
import CenteredWrapper from '../components/CenteredWrapper.js';
import Footer from './Footer.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Camara from "./Camara.js"
import Visualizarpdf from "../components/Visualizarpdf";
import FormRegistroContrasenia from './FormRegistroContrasenia';
import { Navigate } from 'react-router-dom';
import equis from "../../assets/eliminar.svg";
import alerta from "../../assets/alarma.svg";
import anuncioico from "../../assets/AnuncioICO.svg";
import Renderpdf from "../components/renderPDF";
import BotonExpandible from "../components/BotonExpandible";
import NotificacionTip from "./NotificacionTip";
import MenuUsuario from './MenuUsuario';


export class Acuerdo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showEnvAcdRect:false,
            aceptoAcuerdo: false,
            modalPrevAcuerdoGen: this.props.modalPrevAcuerdoGen,
            mostrarNombre:false,
            IsFirmadoElect:false,
            modalFirmaGeneralExitosa: false,
            firmadoGeneral: this.props.firmadoGeneral,
            modalFirmaManual: false,
            modalFirmaManualActualizararch:false,
            verbtngeneral: this.props.verbtngeneral,
            modalFirmaElectronica: false,
            modalFManualExitosa: false,
            modalFManualExitosaTipoA: false,
            modalActualizaciónDocsExitosa: false,
            modalFElectricaExitosa: false,
            modalCamararostro: false,
            modalCamaracedula: false,
            modalModocedula: false,
            modalfotocedula: false,
            modalarchivocedula: false,
            modalSubirPdf: false,
            modalNoAcepACGeneral: false,
            modalNoAcepACGeneralprev: false,
            iconGuardRostroExito: false,
            iconGuardCedulaExito: false,
            isvalidimgpersonasub: false,
            isvalidimgtarjetasub:false,
            isvalidcontratosub: false,
            iconGuardPdfExito: false,
            showiconGuardPdfExitoCedula: false,
            iconChooseFirma: false,
            actFirmaElec: false,
            actFirmaElecInter: false,
            verRegistroContrasena: false,
            showPassword: false,
            activebutton: true,
            activebuttonpdf: true,
            activebutton1: true,
            IsAcuerdoDescargado: false,
            modalMensaje: "",
            idAcFirmaElec: "",
            acuerdob64: "",
            mensaje_titulo: this.props.mensaje_titulo,
            datosUsuario: {
                //SECCIÓN DE LA CUENTA ELECTRÓNICA
                id: this.props.id,
                nombres: this.props.nombres,
                apellidos: this.props.apellidos,
                identificacion: this.props.identificacion,
                usuario_sugerido: this.props.usuario_sugerido,
                //nombres: "pepito pivuawe",
                //apellidos: "gomez rendom",
                //identificacion: "0931087209",
                //usuario_sugerido: "aiarias",
                alias_sugerido: this.props.alias_sugerido,
                correoAlterno: this.props.correoAlterno,
                rol: this.props.rol,
                telefono: this.props.telefono,
                unidad: this.props.unidad,
                password: this.props.password,
                //SECCIÓN DE SOLICITUD MANUAL
                estado: this.props.estado,
                Motivo: this.props.Motivo,
                tipoForm: this.props.tipoForm,
                infoSolicitud: this.props.infoSolicitud,
          },
            isvalidbtnAceptar:false,
            contra: {
                contrasena: "",
                contrasenaCumple: false,
                repetirContraCumple: false,
                terminos: "",
            },
            fotoRostro: '',
            fotoCedula: '',
            pdfData: null,
            pdfCedulaData: null,
            // modalSugerencia: {
            modalError: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: equis,
            },
            modalErrorAcuerdoGen:{
                show: false,
                titulo: "",
                mensaje: "",
                imagen: equis,
            },
            renderNavigateLogin: false,
            base64FE: "",
            pwdFirmaElectronica: "",
            fecha: new Date(),
            verbtngeneralElectronica: this.props.verbtngeneralElectronica,
            token_entraID: sessionStorage.getItem("access_token"),

        };

        this.cambiarEstado = this.cambiarEstado.bind(this);

        this.renderRegistro = this.renderRegistro.bind(this);

        this.abrirModalFirmaM = this.abrirModalFirmaM.bind(this);
        this.cerrarModalFirmaM = this.cerrarModalFirmaM.bind(this);

        this.abrirmodalFirmaManualActualizararch = this.abrirmodalFirmaManualActualizararch.bind(this);
        this.cerrarmodalFirmaManualActualizararch = this.cerrarmodalFirmaManualActualizararch.bind(this);
        


        this.abrirModalFirmaE = this.abrirModalFirmaE.bind(this);
        this.cerrarModalFirmaE = this.cerrarModalFirmaE.bind(this);

        this.abrirModalFManualExitosa = this.abrirModalFManualExitosa.bind(this);
        this.cerrarModalFManualExitosa = this.cerrarModalFManualExitosa.bind(this); 

        this.abrirModalActualizaciónDocsExitosa = this.abrirModalActualizaciónDocsExitosa.bind(this);
        this.cerrarModalActualizaciónDocsExitosa = this.cerrarModalActualizaciónDocsExitosa.bind(this);

        this.abrirModalNoAcepACGeneral = this.abrirModalNoAcepACGeneral.bind(this);
        this.cerrarModalNoAcepACGeneral = this.cerrarModalNoAcepACGeneral.bind(this);

        this.abrirModalNoAcepACGeneralPrev = this.abrirModalNoAcepACGeneralPrev.bind(this);
        this.cerrarModalNoAcepACGeneralPrev = this.cerrarModalNoAcepACGeneralPrev.bind(this);

        this.abrirModalFElectronicaExitosa = this.abrirModalFElectronicaExitosa.bind(this);
        this.cerrarModalFElectronicaExitosa = this.cerrarModalFElectronicaExitosa.bind(this);

        this.abrirModalCamararostro = this.abrirModalCamararostro.bind(this);
        this.cerrarModalCamararostro = this.cerrarModalCamararostro.bind(this);

        this.abrirModalCamaracedula = this.abrirModalCamaracedula.bind(this);
        this.cerrarModalCamaracedula = this.cerrarModalCamaracedula.bind(this);

        this.abrirModalModoacedula = this.abrirModalModoacedula.bind(this);
        this.cerrarModalModocedula = this.cerrarModalModocedula.bind(this);

        this.abrirmodalarchivocedula = this.abrirmodalarchivocedula.bind(this);
        this.cerrarmodalarchivocedula = this.cerrarmodalarchivocedula.bind(this);


        this.abrirmodalfotocedula = this.abrirmodalfotocedula.bind(this);
        this.cerrarmodalfotocedula = this.cerrarmodalfotocedula.bind(this);

        this.abrirModalSubirPdf = this.abrirModalSubirPdf.bind(this);
        this.cerrarModalSubirPdf = this.cerrarModalSubirPdf.bind(this);

        this.showiconGuardRostroExito = this.showiconGuardRostroExito.bind(this);
        this.showiconGuardCedulaExito = this.showiconGuardCedulaExito.bind(this);
        this.showiconGuardPdfExito = this.showiconGuardPdfExito.bind(this);
        this.showiconGuardPdfExitoCedula = this.showiconGuardPdfExitoCedula.bind(this);


        this.verFormRegistroContrasenia = this.verFormRegistroContrasenia.bind(this);

        this.mostrarContrasena = this.mostrarContrasena.bind(this);

        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);

        this.abrirModalErrorGen = this.abrirModalErrorGen.bind(this);
        this.cerrarModalErrorGen = this.cerrarModalErrorGen.bind(this);

        this.activebuttonf = this.activebuttonf.bind(this);
        this.disabledbuttonf = this.disabledbuttonf.bind(this);


        this.activebuttonpdf = this.activebuttonpdf.bind(this);
        this.disabledbuttonpdf = this.disabledbuttonpdf.bind(this);

        this.abrirModalFirmaGeneralExitosa = this.abrirModalFirmaGeneralExitosa.bind(this);
        this.cerrarModalFirmaGeneralExitosa = this.cerrarModalFirmaGeneralExitosa.bind(this);

        this.cerrarModalPrevGen = this.cerrarModalPrevGen.bind(this);
        this.abrirModalPrevGen = this.abrirModalPrevGen.bind(this);

        var servicio = localStorage.getItem('servicio');        
        //console.log(servicio);
    }

    componentWillMount() {
        //this.props.useEffect();
    }

    cerrarModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: false,
        });
    }

    abrirModalPrevGen() {
        this.setState({
            modalPrevAcuerdoGen: true,
        });
    }

    activebuttonf() {
        this.setState({ activebutton: true });
    }

    disabledbuttonf() {
        this.setState({ activebutton: false });
    }


    activebuttonpdf() {
        this.setState({ activebuttonpdf: true });
    }

    disabledbuttonpdf() {
        this.setState({ activebuttonpdf: false });
    }


    activebuttonf1() {
        this.setState({ activebutton1: true });
    }

    disabledbuttonf1() {
        this.setState({ activebutton1: false });
    }
    mostrarContrasena(e) {
        e.preventDefault();
        this.setState({ showPassword: !this.state.showPassword });
    }

    verFormRegistroContrasenia() {
        this.setState({ verRegistroContrasena: true });
    }

    showiconGuardRostroExito() {
        this.setState({
            iconGuardRostroExito: true,
            actFirmaElec: true,
            isvalidimgpersonasub: true
        });
        ///this.setState({  })
    }

    showiconGuardCedulaExito() {
        this.setState({
            iconGuardCedulaExito: true,
            actFirmaElec: true,
            isvalidimgtarjetasub: true
        });
        //this.setState({ actFirmaElec: true })
    }
    showiconGuardPdfExito() {
        this.setState({
            iconGuardPdfExito: true,
            actFirmaElec: true,
            isvalidcontratosub:true,
            })
        //this.setState({ actFirmaElec: true })
    }

    showiconGuardPdfExitoCedula() {
        this.setState({
            iconGuardCedulaExito: true,
            isvalidimgtarjetasub: true,
        })
    }

    abrirModalCamararostro() {
        this.setState({ modalCamararostro: true })
       
    }

    cerrarModalCamararostro() {
        this.setState({ modalCamararostro: false })
    }

    abrirModalCamaracedula() {
        this.setState({ modalCamaracedula: true });
        this.cerrarModalModocedula();
    }

    cerrarModalCamaracedula() {
        this.setState({ modalCamaracedula: false })
    }

    abrirModalModoacedula() {
        this.setState({ modalModocedula: true })
    }

    cerrarModalModocedula() {
        this.setState({ modalModocedula: false })
    }

    abrirmodalfotocedula() {
        this.setState({ modalfotocedula: true })
    }

    cerrarmodalfotocedula() {
        this.setState({ modalfotocedula: false })
    }


    abrirmodalarchivocedula() {
        this.setState({ modalarchivocedula: true });
        this.cerrarModalModocedula();
    }

    cerrarmodalarchivocedula() {
        this.setState({ modalarchivocedula: false })
    }


    abrirModalSubirPdf() {
        this.setState({ modalSubirPdf: true })
    }

    cerrarModalSubirPdf() {
        this.setState({
            modalSubirPdf: false,
            modalarchivocedula: false
        })
    }


    abrirModalFManualExitosa() {
        this.setState({ modalFManualExitosa: true })
    }


    cerrarModalActualizaciónDocsExitosa() {
        this.setState({ modalActualizaciónDocsExitosa: false });
        window.location.href = "/Inicio";
    }

    abrirModalActualizaciónDocsExitosa() {
        this.setState({
            modalActualizaciónDocsExitosa: true,
            modalFirmaManualActualizararch: false
        })
    }


    cerrarModalFManualExitosa() {
        this.setState({ modalFManualExitosa: false })
        this.setState({ renderNavigateLogin: true })
    }


    abrirModalFManualExitosaTipoA() {
        this.setState({ modalFManualExitosaTipoA: true })
    }


    cerrarModalFManualExitosaTipoA() {
        this.setState({ cerrarModalFManualExitosaTipoA: false })
        //this.setState({ renderNavigateLogin: true })
    }

    abrirModalNoAcepACGeneral() {
        this.cerrarSesion();
        this.setState({
            modalNoAcepACGeneralprev: false,
            modalNoAcepACGeneral: true,
        })
    }

    cerrarModalNoAcepACGeneral() {
        this.setState({ modalNoAcepACGeneral: false });
        this.redireccion(2);
    }


    abrirModalNoAcepACGeneralPrev() {
        this.setState({ modalNoAcepACGeneralprev: true })
    }

    cerrarModalNoAcepACGeneralPrev() {
        this.setState({ modalNoAcepACGeneralprev: false });
        //window.location.href = "/Inicio";
    }


    abrirModalFirmaGeneralExitosa() {
        this.setState({ modalFirmaGeneralExitosa: true });
    }

    descargarAcuerdoFirmaManual = () => {
      //  console.log("acuerdo descargado");
        this.setState({
            IsAcuerdoDescargado: true
        });

    }

    redireccion(op){
        var servicio = localStorage.getItem('servicio');
        //var servicio= 'http://192.168.253.7:8087/signin-cas?state=CfDJ8ENUpIgaTURAmA9EfHzh5f_Lch0GfZ_iDfGlUeZCSyG4EJelJbNceGLijKHOhz7kjdastRgI99re7jIlfh5-9AyqwBDse8zIk0HzNcMqxo0XPJthDUMtgb4Oauq4dxlyM52VGZ2ZIHVbQw9n3ZFnusnv4ollNHpTE1pTZzMJhZoS8mUeC9VcUCPqCeV7HE6pig6AoufL7tGLWeD5QFqihyk';
        //console.log(servicio);
        if (servicio === null || servicio === undefined) {
            window.location.href = "/Inicio";
            //}else if(servicio=="https://www.academico.espol.edu.ec/"){
        } else if (servicio.includes("?service=https://www.academico.espol.edu.ec/")) {
            var ruta = 'https://www.academico.espol.edu.ec/login.aspx';
            window.location.href = ruta;
        } else if (servicio.includes("?service=https://www.profesor.espol.edu.ec/")) {
            var ruta = 'https://www.profesor.espol.edu.ec/Account/AuthLogin';
            window.location.href = ruta;
        }else if (op === 1) {
            if (this.props.tipoAcuerdo == "ALUMNI") {
                //window.location.href = 'https://alumni.espol.edu.ec/';
                ruta = servicio;
            } else {
                var ruta = 'https://auth.espol.edu.ec/login' + servicio;
            }
            window.location.href = ruta;
        } else {
            if (this.props.tipoAcuerdo == "ALUMNI") {
                //window.location.href = 'https://alumni.espol.edu.ec/';
                window.location.href = servicio;
            } else {
               window.location.href = 'https://auth.espol.edu.ec/logout';
            }
        }
        localStorage.removeItem('servicio'); //cerrar
    }

    cerrarModalFirmaGeneralExitosa() {
        this.setState({ modalFirmaGeneralExitosa: false });
        this.cerrarSesion();
        this.redireccion(1);

    }


    abrirModalFElectronicaExitosa() {
        this.setState({ modalFElectricaExitosa: true })
    }

    cerrarModalFElectronicaExitosa() {
        this.setState({ modalFElectricaExitosa: false })
        this.setState({ renderNavigateLogin: true })

    }

    abrirModalFirmaM() {
        this.props.callTagManager("click-btn-fir-man-creacion")
       // console.log(this.state.verbtngeneralElectronica);
        if (this.state.verbtngeneralElectronica) {
            this.setState({
                modalFirmaManual: true,
                modalFirmaManualActualizararch: false
            });
        } else {
            this.setState({
                modalFirmaManualActualizararch: true,
                modalFirmaManual: false,
            });
        }
        
        //console.log(this.state.datosUsuario);
    }

    cerrarModalFirmaM() {
        this.setState({ modalFirmaManual: false });
    }

    abrirmodalFirmaManualActualizararch() {
        this.setState({ modalFirmaManualActualizararch: true });
        //console.log(this.state.datosUsuario);
    }

    cerrarmodalFirmaManualActualizararch() {
        this.setState({ modalFirmaManualActualizararch: false });
    }


    abrirModalFirmaE() {
        this.props.callTagManager("click-btn-fir-elec-creacion");
        this.setState({ modalFirmaElectronica: true })
    }

    cerrarModalFirmaE() {
        this.setState({ modalFirmaElectronica: false })
    }

    abrirModalError() {
        this.setState({
            modalError: {
                ...this.state.modalSugerencia,
                show: true
            }
        });
    }

    cerrarModalError() {
        this.setState({
            modalError: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
    }

    abrirModalErrorGen() {
        this.setState({
            modalErrorAcuerdoGen: {
                ...this.state.modalSugerencia,
                show: true
            }
        });
    }

    cerrarModalErrorGen() {
        this.setState({
            modalErrorAcuerdoGen: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        },()=>{
            this.redireccion(2);
        });
    }

    handlerDatosFormRegistro = async (e) => {
        await this.setState({
            contra: {
                ...this.state.contra,
                [e.target.name]: e.target.value,
                terminos: e.target.checked
            }
        })
        //console.log(this.state.contra);

    }


  handlerCheckPrev = async (e) => {
    if (this.state.aceptoAcuerdo) {
      await this.setState({
        aceptoAcuerdo: e.target.checked,
        isvalidbtnAceptar: false
      }, () => {
        //console.log(this.state.aceptoAcuerdo);
        //console.log(this.state.isvalidbtnAceptar);
      })
    } else {
      await this.setState({
        aceptoAcuerdo: e.target.checked,
        isvalidbtnAceptar: true
      }, () => {
        //console.log(this.state.aceptoAcuerdo);
        //console.log(this.state.isvalidbtnAceptar);
      })
    }
        
  }

    cambiarEstado(valor, contraCumple, repetirContraCumple) {
        this.setState({
            contra: {
                ...this.state.contra,
                contrasena: valor,
                contrasenaCumple: contraCumple,
                repetirContraCumple: repetirContraCumple
            }
        })
        //console.log("CAMBIAR ESTADO");
        //console.log(this.state.contra);
    }

    renderRegistro(e) {
        e.preventDefault();

        this.props.renderFormRegistro(false);
        //console.log("cambio form registro contraseña");
    }

    /* acuerdo firmado de forma electronica*/
    postFirmarAcuerdoElectronicamente = async (e) => {
        this.props.callTagManager("click-btn-subir-acuerdo-elec-creacion");
        e.preventDefault();
        this.disabledbuttonf();

        var signDoc = {
            nombre: this.state.datosUsuario.nombres,
            apellido: this.state.datosUsuario.apellidos,
            identificacion: this.state.datosUsuario.identificacion,
            firmaBase64: this.state.base64FE,
            password: this.state.pwdFirmaElectronica,
            acuerdoBase64: this.state.acuerdob64,
        }
        this.setState({
            IsFirmadoElect: true,
        });

        axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/signDoc`, signDoc, {
        headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
        }
        })
        .then(resp => {
            this.state.idAcFirmaElec = resp.data;
            if (this.state.datosUsuario.tipoForm == "A") {
                this.verFormRegistroContrasenia();
            } else {
                var solicitud = {
                    estado: this.state.datosUsuario.estado,
                    identificacion: this.state.datosUsuario.identificacion,
                    infoSolicitud: this.state.datosUsuario.infoSolicitud,
                    Motivo: this.state.datosUsuario.Motivo,
                    idAcuerdoFirmadoElec: this.state.idAcFirmaElec,
                    tipoAcuerdo: "D",
                }
                axios.post(`${process.env.REACT_APP_API}api/Solicitud`, solicitud, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
                    }
                })
                .then(resp => {
                    this.abrirModalFElectronicaExitosa();
                    this.activebuttonf();
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        this.setState({
                            modalError: {
                            show: true,
                            titulo: "Error con validación del token",
                            mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                            imagen: equis,
                            }
                        });
                    }else if (error.response.data.errorMessage = "Captcha invalido.") {
                        this.setState({
                        modalError: {
                            show: true,
                            titulo: "Error con validación del captcha",
                            mensaje: error.response.data.errorMessage,
                            imagen: equis,
                        }
                        });
                    } else {
                        this.setState({
                        modalError: {
                            show: true,
                            titulo: "Error al guardar la solicitud",
                            mensaje: "Existe un problema al guardara la solicitud. Por favor, intentarlo mas tarde.",
                            imagen: equis,
                        }
                        });
                        this.activebuttonf();
                    }
                });
            }
        }).catch(error => {
            this.activebuttonf();
            if (error.response && error.response.status === 401) {
                this.setState({
                    modalError: {
                    show: true,
                    titulo: "Error con validación del token",
                    mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                    imagen: equis,
                    }
                });
            }else if (error.response.data.errorMessage) {
                this.setState({
                    modalError: {
                    show: true,
                    titulo: "Error en la firma electronica",
                    mensaje: error.response.data.errorMessage,
                    imagen: equis,
                    }
                });
            } else {
                this.setState({
                    modalError: {
                    show: true,
                    titulo: "Error en la firma electronica",
                    mensaje: "Existió un problema con el servidor",
                    imagen: equis,
                    }
                });
            }
        })
    }

    FirmarAcuerdoAlumni = async (e) => {
        e.preventDefault();
        if (this.state.aceptoAcuerdo) {
            this.PostFirmarAcuerdoGen(e);
        } else {
            window.location.href = 'https://alumni.espol.edu.ec/'
        }
    }

    


    PostFirmarAcuerdoGen = async (e) => {
        e.preventDefault();
        this.disabledbuttonf();
        this.setState({
            mostrarNombre:true,
        })
        var signDoc = {
            nombre: this.state.datosUsuario.nombres,
            apellido: this.state.datosUsuario.apellidos,
            identificacion: this.state.datosUsuario.identificacion,
            acuerdoBase64: this.state.acuerdob64,
            usuario: this.state.datosUsuario.usuario_sugerido,
            firmaBase64: this.state.base64FE,
            password: this.state.pwdFirmaElectronica,
        }

        axios.post(`${process.env.REACT_APP_API}api/CuentaUsuario/notsignDoc`, signDoc)
            .then(resp => {
                let enlace = resp.data;
                if (resp.status == 200 && resp.data != " ") {
                    let datos = {
                        estado: 1,
                        aceptodatospers: 1,
                        aceptomedelect: 1,
                        rutaacuerdodatospersfirmado: enlace,
                        rutaacuerdomedelectfirmado: enlace,
                        identificacion: this.state.datosUsuario.identificacion,
                    }
                    axios.post(`${process.env.REACT_APP_API}api/persona/firmaracuerdo`, datos, {
                            headers: {
                                Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
                            }
                        })
                        .then(resp => {
                            this.abrirModalFirmaGeneralExitosa();
                            this.activebuttonf();
                        }).catch(error => {
                            if (error.response && error.response.status === 401) {
                                this.setState({
                                    modalError: {
                                    show: true,
                                    titulo: "Error con validación del token",
                                    mensaje: "El token EntraID del usuario ha expirado. Por favor comience el proceso nuevamente.",
                                    imagen: equis,
                                    }
                                });
                            } else {
                                this.setState({
                                    modalErrorAcuerdoGen: {
                                        show: true,
                                        titulo: "Error al guardar el registro de la firma",
                                        mensaje: error.response.data.errorMessage,
                                        imagen: equis,
                                    }
                                });
                            }
                            this.activebuttonf();
                        });
                }
            }).catch(error => {
                this.setState({
                    modalErrorAcuerdoGen: {
                        show: true,
                        titulo: "Error al guardar el documento firmado",
                        mensaje: "Existe un problema al guardara el acuerdo. <br/>Por favor, intentarlo mas tarde.",
                        imagen: equis,
                    } 
                });
                this.activebuttonf();
            })
    }

    PostNoFirmarAcuerdoGen = async (e) => {
        e.preventDefault();
        this.disabledbuttonf1();
      
        let datos = {
            estado: 1,
            aceptodatospers: 0,
            aceptomedelect: 0,
            rutaacuerdodatospersfirmado: "",
            rutaacuerdomedelectfirmado: "",
            identificacion: this.state.datosUsuario.identificacion,
        }
        axios.post(`${process.env.REACT_APP_API}api/persona/firmaracuerdo`, datos, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
                }
            })
            .then(resp => {
                this.activebuttonf1();
                this.abrirModalNoAcepACGeneralPrev();
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    this.setState({
                        modalError: {
                        show: true,
                        titulo: "Error con validación del token",
                        mensaje: "El token EntraID del usuario ha expirado. Por favor comience el proceso nuevamente.",
                        imagen: equis,
                        }
                    });
                }else{
                    this.setState({
                        modalErrorAcuerdoGen: {
                            show: true,
                            titulo: "Error al guardar el registro de la firma",
                            mensaje: error.response.data.errorMessage,
                            imagen: equis,
                        }
                    });
                }
                this.activebuttonf1();
            });
    }

    /*Acuerdo firmado de forma manual*/
    postCrearCuenta = async (e) => {
        this.props.callTagManager("click-btn-subir-acuerdo-man-creacion");
        e.preventDefault();

        this.disabledbuttonf();
        if (this.state.datosUsuario.tipoForm == "A") {
            //Para crear una cuenta con firma manual y sube foto de rostro,cedula y pdf firmado manualmente que viene del registro automatico
            //PRIMERO SUBO EL ACUERDO PARA OBTENER EL ENLACE Y PASARSELO A verFormRegistroContrasenia(); -> CREO LA CUENTA Y LUEGO CREO LA SOLICITUD.
            var datadoc = {
                nombres: this.state.datosUsuario.nombres,
                apellidos: this.state.datosUsuario.apellidos,
                Identificacion: this.state.datosUsuario.identificacion,
                filePdf: this.state.pdfData,
            }
            axios.post(`${process.env.REACT_APP_API}api/Solicitud/uploadfile`, datadoc, {
                    headers: {
                        Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
                    }
                })
                .then(resp => {
                    this.setState({
                        idAcFirmaElec: resp.data,
                    }, () => {
                        /*REDIRECCIÓN A REGISTRO CONSTRASEÑA PARQ QUE SE CREE DIRECTAMENTE LA CUENTA CON EL ACTIVE DIRECTORY */
                        this.verFormRegistroContrasenia();
                    })
                    this.activebuttonf();
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                         this.setState({
                            modalError: {
                            show: true,
                            titulo: "Error con validación del token",
                            mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                            imagen: equis,
                            }
                        });
                    } else if (error.response.data.errorMessage = "Captcha invalido.") {
                        this.setState({
                            modalError: {
                            show: true,
                            titulo: "Error con validación del captcha",
                            mensaje: error.response.data.errorMessage,
                            imagen: equis,
                            }
                        });
                    } else {
                    this.setState({
                        modalError: {
                        show: true,
                        titulo: "Error en el envio de solicitud",
                        mensaje: "Existio un problema al enviar la solicitud",
                        imagen: equis,
                        }
                    });
                    }
                    this.activebuttonf();
                });
        } else {
            var f = this.state.pdfData;

            var solicitud = {
                estado: this.state.datosUsuario.estado,
                identificacion: this.state.datosUsuario.identificacion,
                infoSolicitud: this.state.datosUsuario.infoSolicitud,
                Motivo: this.state.datosUsuario.Motivo,
                fotoimgRostro: this.state.fotoRostro,
                fotoimgCedula: this.state.fotoCedula,
                filePdf: this.state.pdfData,
                tipoAcuerdo: "M",
            }
            axios.post(`${process.env.REACT_APP_API}api/Solicitud`, solicitud, {
                headers: {
                    Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
                }
            })
            .then(resp => {
                this.abrirModalFManualExitosa();
                this.activebuttonf();
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                        this.setState({
                            modalError: {
                            show: true,
                            titulo: "Error con validación del token",
                            mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                            imagen: equis,
                            }
                        });
                }else if (error.response.data.errorMessage = "Captcha invalido.") {
                    this.setState({
                        modalError: {
                        show: true,
                        titulo: "Error con validación del captcha",
                        mensaje: error.response.data.errorMessage,
                        imagen: equis,
                        }
                    });
                } else {
                    this.setState({
                        modalError: {
                        show: true,
                        titulo: "Error en el envio de solicitud",
                        mensaje: "Existio un problema al enviar la solicitud",
                        imagen: equis,
                        }
                    });
                }
                this.activebuttonf();
            });
        }
    }


    postRectificarDocs = async (e) => {
        e.preventDefault();
        this.disabledbuttonf();

        var solicitud = {
            estado: "Rechazado cc",
            Motivo: "Rechazado cc",
            Identificacion: this.state.datosUsuario.identificacion,
            isvalidimgpersona: this.props.documentosValidos.isvalidimgpersona,
            isvalidimgtarjeta: this.props.documentosValidos.isvalidimgtarjeta,
            isvalidcontrato: this.props.documentosValidos.isvalidcontrato,
            fotoimgCedula: this.state.fotoCedula,
            fotoimgRostro: this.state.fotoRostro,
            filePdf: this.state.pdfData,
        }

        axios.put(`${process.env.REACT_APP_API}api/Solicitud/repalaceDocs/${this.props.idSolicitud}`, solicitud, {
            headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token_nueva_cuenta")}`
            }
        })
            .then(resp => {
                this.activebuttonf();
                this.abrirModalActualizaciónDocsExitosa();
            }).catch(error => {
                if (error.response && error.response.status === 401) {
                    this.setState({
                        modalError: {
                        show: true,
                        titulo: "Error con validación del token",
                        mensaje: "El token del usuario ha expirado. Por favor comience el proceso nuevamente.",
                        imagen: equis,
                        }
                    });
                } else{
                    this.setState({
                        modalError: {
                            show: true,
                            titulo: "Error en la solicitud de actualización de documentos de la firma del acuerdo manual",
                            mensaje: error.response.data.errorMessage,
                            imagen: equis,
                        }
                    });;
                }
                this.activebuttonf();
            });
    }


    DataAcuerdo = arcb64 => {
        this.state.acuerdob64 = arcb64;
    }

    Dataimgrostro = dataimgros => {
        if (dataimgros === null) {
            //console.log("No es una foto adecuada del rostro.");
        } else {
            this.state.fotoRostro = dataimgros
            this.cerrarModalCamararostro();
            this.showiconGuardRostroExito();
            this.state.actRostro = true;
        }
    }

    Dataimgcedula = dataimgced => {
        if (dataimgced === null) {
           // console.log("No es una foto adecuada de la cedula");
        } else {
            this.state.fotoCedula = dataimgced;
            this.cerrarModalCamaracedula();
            this.showiconGuardCedulaExito();
            this.state.actCedula = true;
        }
    }

    filechoose = chosefile => {
        if (chosefile === null) {
            //console.log("No es una foto adecuada de la cedula");
        } else {
            this.state.pdfData = chosefile;
            this.cerrarModalSubirPdf();
            this.showiconGuardPdfExito();
            this.state.actDocPdf = true;
        }
    }

    filechooseCedula = chosefile => {
       //console.log(chosefile);
        if (chosefile === null) {
           //console.log("No es una foto adecuada de la cedula");
        } else {
            //console.log(chosefile);
            // this.state.pdfCedulaData = chosefile;
            this.state.fotoCedula = chosefile;
            this.cerrarmodalarchivocedula();
            this.showiconGuardPdfExitoCedula();
            this.state.actDocPdf = true;
        }
    }

    handleFile = async (e) => {
        let selectedFile = e.target.files[0];
        //console.log(selectedFile);
        if (selectedFile) {
            let reader = new FileReader();
            reader.readAsDataURL(selectedFile);
            reader.onloadend = (e) => {
                this.state.base64FE = e.target.result;
                this.setState({ iconChooseFirma: true });
            }
        }
        else {
        }
    }

    handlerPassword = async (e) => {
        this.state.pwdFirmaElectronica = e.target.value;
        if (this.state.iconChooseFirma && this.state.pwdFirmaElectronica) {
            this.setState({ actFirmaElecInter: true });
        } else {
            this.setState({ actFirmaElecInter: false });

        }
    }

    cerrarSesion = async () => {
        Cookies.remove("token");
        Cookies.remove("cas");
        Cookies.remove("DatosPersonalesGIA.CAS");
        
    }

    render() {
        return (
            this.state.renderNavigateLogin ? <Navigate to="/inicio" /> :
                (
                    this.state.verRegistroContrasena ?
                        <FormRegistroContrasenia
                            identificacion={this.state.datosUsuario.identificacion}
                            nombres={this.state.datosUsuario.nombres}
                            apellidos={this.state.datosUsuario.apellidos}
                            alias_sugerido={this.state.datosUsuario.alias_sugerido}
                            usuario_sugerido={this.state.datosUsuario.usuario_sugerido}
                            correoAlterno={this.state.datosUsuario.correoAlterno}
                            rol={this.state.datosUsuario.rol}
                            telefono={this.state.datosUsuario.telefono}
                            unidad={this.state.datosUsuario.unidad}
                            idAcFirmaElec={this.state.idAcFirmaElec}
                            tipoForm={this.state.datosUsuario.tipoForm}
                            fotoCedula={this.state.fotoCedula}
                            fotoRostro={this.state.fotoRostro}
                            IsFirmadoElect={this.state.IsFirmadoElect}
                            callTagManager={this.props.callTagManager}
                           /* useEffect={this.props.useEffect}*/
                        ></FormRegistroContrasenia>
                        :
                        (
                            <div>
                                {/*<MenuUsuario
                                    mostrarNombre={true}
                                    nombresCompletos={`${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`}
                                />
                                <Header />*/}
                                <CenteredWrapper>
                                    <div className="acuerdo-container">
                                        <div className="container">
                                            <div className="row">
                                                {this.state.firmadoGeneral ?
                                                    (<div>
                                                        
                                                        <p className="acuerdo-title">{this.state.mensaje_titulo}</p>

                                                        <div className="acuerdogeneral-container">
                                                            <div className="container">
                                                                <div className="row">
                                                                    <div >
                                                                        <p className="acuerdogeneral-subtitulo" align="justify"> <img src={anuncioico} className="acuerdogeneral-btn-logop" /> PARA SU CONOCIMIENTO</p>
                                                                        <p className="acuerdogeneral-parraf" align="justify">Estimado, en cumplimiento de la Ley Orgánica de Protección de Datos Personales, tiene que aceptar el siguiente acuerdo para poder hacer uso de los sistemas de la institución:</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>) :
                                                    (
                                                    // <div>
                                                    //     <div >
                                                    //         <p className="acuerdo-title">{this.state.mensaje_titulo}</p>
                                                    //     </div>

                                                    //     <div >
                                                    //         <p className="acuerdo-parraf" align="justify">A continuación tiene que leer y firmar el acuerdo de uso de medios electrónicos. </p>
                                                    //     </div>
                                                    // </div>
                                                    <BotonExpandible 
                                                        mensaje={
                                                        <div style={{ textAlign: "left" }}>
                                                            <strong>
                                                                Si la información presentada no es correcta por favor contactarse con{" "}
                                                                <a href="mailto:gerenciatecnologia@espol.edu.ec">
                                                                gerenciatecnologia@espol.edu.ec
                                                                </a>
                                                            </strong>
                                                            <br /><br />
                                                            <em style={{ fontWeight: 200 }}>
                                                                A continuación tiene que leer y firmar el acuerdo de uso de medios electrónicos.
                                                            </em>
                                                        </div>
                                                                                                                                                
                                                        }
                                                    />
                                                    )
                                                }

                                            </div>
                                        </div>
                                        <br />
                                        <div className="row">
                                            <div className=" col-md-1 col-lg-2 col-xl-1"></div>
                                            <div className=" col-md-10 col-lg-8 col-xl-10 acuerdo-recuadro" align="center">
                                                <div className="row acuerdo-recuadro-titulo mt-4" >
                                                    <p><b>ACUERDO DE USO DE DATOS PERSONALES Y MEDIOS ELECTRÓNICOS PARA EL ALMACENAMIENTO Y USO DE INFORMACIÓN REGISTRADA EN LOS SISTEMAS INFORMÁTICOS DE LA ESPOL.</b></p>
                                                </div>
                                                {/*<div className="row acuerdo-recuadro-subtitulo" >
                                                    <p><b>I.- Autorización para el almacenamiento y uso de información <br /> personal registrada en la ESPOL.</b></p>
                                                </div>*/}
                                                <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                                    <p>La Escuela Superior Politécnica del Litoral – (en adelante ESPOL) es una institución de educación superior, persona jurídica de derecho público, sin fines de lucro, autónoma en lo académico, administrativo, financiero y orgánico, pone en su conocimiento las condiciones de uso, fines y almacenamiento de los datos personales proporcionados por usted; así como, las condiciones de uso del usuario y contraseña de los medios y servicios electrónicos que la ESPOL provee a través del internet.</p>
                                                </div>
                                                <div className="row acuerdo-recuadro-subtitulo-izq" >
                                                    <p><b>Declaración de responsabilidad y aceptación de usuario:</b></p>
                                                </div>
                                                <div className="row mt-2 px-3 acuerdo-recuadro-texto" align="justify">
                                                    <p>Con estos antecedentes. Usted, {this.state.datosUsuario.nombres.toUpperCase()} {this.state.datosUsuario.apellidos.toUpperCase()}, en adelante el Usuario,
                                                        con número de identificación {this.state.datosUsuario.identificacion} y usuario {this.state.datosUsuario.usuario_sugerido} en Guayaquil, Ecuador; el día {this.state.fecha.toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' })},
                                                        declara que:</p>
                                        
                                                    <div className="Aut_dtos_personales" align="justify">

                                                        <p>1) Se compromete a registrar la información requerida por la institución de manera fidedigna y coherente en los sistemas informáticos de la ESPOL.</p>

                                                        <p>2) Acepta y autoriza que la ESPOL almacene sus datos personales por tiempo indefinido, y
                                                            serán protegidos de acuerdo a la Ley Orgánica de Protección de Datos Personales. Estos
                                                            datos podrán ser compartidos con las empresas públicas, fundaciones y empresas con las que                                                  
                                                            la ESPOL esté relacionada, enmarcado en los fines del tratamiento de datos personales
                                                            dispuesto en las políticas de privacidad de la institución.
    </p>

                                                        <p>3) Acepta y autoriza que la ESPOL haga uso de los datos personales proporcionados, en
                                                            concordancia con la  <a target="_blank" href="https://www.dspace.espol.edu.ec/bitstream/123456789/57243/3/POLITICA%20DE%20PRIVACIDAD%20ESPOL%20GTSI.pdf">Política de Privacidad</a> y en sus <a target="_blank" href="https://www.dspace.espol.edu.ec/bitstream/123456789/57244/3/TERMINOS%20Y%20CONDICIONES%20POLITICAS%20DE%20PRIVACIDAD%20GTSI.pdf">términos y condiciones</a> vigentes de la
                                                            institución.</p>

                                                        <p>4) Conoce que su calidad de usuario de los sistemas informáticos de la ESPOL, permite a la
                                                            institución el uso de sus datos personales sensibles de acuerdo a la Ley Orgánica de
                                                            Protección de Datos Personales y que los mismos serán utilizados como parte de su registro
                                                            académico. </p>
                                                        <p>5) Conoce que el portal institucional www.espol.edu.ec es de propiedad de la Escuela Superior Politécnica del Litoral.</p>
                                                        <p>6) Conoce el presente acuerdo y se compromete, a respetar las normas y procedimientos que garanticen la privacidad de la información proporcionada o de la que pudiera tener acceso.</p>

                                                        <p>7) Asume la responsabilidad de la información proporcionada; así como también de la vigencia, veracidad, actualización y coherencia de la misma, en cumplimiento de sus obligaciones.</p>
                                                        <p>8) Conoce que, de incurrir en uso inadecuado de los sistemas informáticos de la institución, la ESPOL tendrá derecho tomar las medidas tecnológicas necesarias sobre el usuario de sus sistemas informáticos para precautelar la seguridad informática de los mismos. También, la institución podrá iniciar medidas administrativas correctivas, en caso de falsedad de la información ingresada, mal uso, vulneración de sistemas, entre otras actividades que pudieran poner en riesgos la confidencialidad de datos bajo responsabilidad y custodia de la ESPOL, sin perjuicio de las acciones judiciales que pudiera iniciar la institución.</p>
                                                        <p>9) Conoce que la marca ´´ESPOL + logotipo´´ y sus marcas derivadas se encuentran registradas y gozan de protección de los Derechos de Propiedad Intelectual. En caso de requerir su uso, deberá ser autorizado por la institución.</p>
                                                        <p>10) Conoce que las imágenes, portales, archivos, documentos o cualquier otro material en el que conste la ESPOL + logotipo o sus marcas registradas, es propiedad de la institución, su uso o reproducción deberá ser autorizada, o mencionada dentro del medio para el que se utilice.</p>
                                                        <p>11) Conoce que el usuario y clave que la institución le asigne es personal e intransferible, su uso en las plataformas web de la ESPOL, tendrá validez jurídica de una firma electrónica, de conformidad a lo indicado en la Ley de Comercio Electrónico, Mensaje de Datos y Firma Electrónica y su Reglamento.</p>
                                                        
                                                    </div>
                                                    <Renderpdf nombre={this.state.datosUsuario.nombres} apellido={this.state.datosUsuario.apellidos}
                                                        identificacion={this.state.datosUsuario.identificacion} username={this.state.datosUsuario.usuario_sugerido} arcb64={this.DataAcuerdo} firmadoGeneral={this.state.firmadoGeneral} mostrarNombre={this.state.mostrarNombre} posicion="nomodal"/>
                                                </div>
                                                {
                                                    // false ?
                                                    !this.state.verbtngeneral ?
                                                        (<div className="row my-3  justify-content-around">
                                                            <div className="col-10 col-md-8 col-xl-5" >
                                                                <button onClick={this.abrirModalFirmaM} className="acuerdo-recuadro-buttonFM">
                                                                    <div className="row" style={{justifyContent: 'center'}} >
                                                                        {/* <div className="col-2 col-md-2 col-xl-2"  >
                                                                            <img className="acuerdo-logopFM" src={subaacfm} alt="crearcuenta" />
                                                                        </div> */}
                                                                        <div className="col-10 col-md-10 col-xl-10">
                                                                            <p className="acuerdo-recuadro-texto-button">FIRMA MANUAL</p>
                                                                        </div>

                                                                    </div>
                                                                </button>
                                                            </div>

                                                            {this.props.verbtngeneralElectronica &&
                                                                <div className=" col-10 col-md-8 col-xl-5" >
                                                                    <button onClick={this.abrirModalFirmaE}
                                                                        className="acuerdo-recuadro-buttonFE">
                                                                        <div className="row" style={{justifyContent: 'center'}} >
                                                                            {/* <div className=" col-2 col-md-2 col-xl-2">
                                                                                <img className="acuerdo-logopFE" src={subaacfe} alt="crearcuenta" />

                                                                            </div> */}
                                                                            <div className=" col-10 col-md-10 col-xl-10">
                                                                                <p className="acuerdo-recuadro-texto-button">FIRMA ELECTRÓNICA</p>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                </div>
                                                            
                                                            }
                                                        </div>
                                                        ) :
                                                        (
                                                            <div className="row my-3  justify-content-around">
                                                                <div className="col-10 col-md-8 col-xl-5" >
                                                                    <button onClick={this.PostFirmarAcuerdoGen} className="acuerdo-recuadro-buttonFM">
                                                                        <div className="row" >
                                                                            <div className="col-2 col-md-2 col-xl-2"  >
                                                                                <img className="acuerdo-logopFM" src={check} alt="crearcuenta" />
                                                                            </div>
                                                                            <div className="col-10 col-md-10 col-xl-10">
                                                                                <p className="acuerdo-recuadro-texto-button">Acepto</p>
                                                                            </div>

                                                                        </div>
                                                                    </button>
                                                                    {!this.state.activebutton ?
                                                                        <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>
                                                                        : null}
                                                                </div>

                                                                <div className=" col-10 col-md-8 col-xl-5" >
                                                                    <button onClick={this.PostNoFirmarAcuerdoGen}
                                                                        className="acuerdo-recuadro-buttonFE">
                                                                        <div className="row">
                                                                            <div className=" col-2 col-md-2 col-xl-2">
                                                                                <img className="acuerdo-logopFE" src={eliminar} alt="crearcuenta" />

                                                                            </div>
                                                                            <div className=" col-10 col-md-10 col-xl-10">
                                                                                <p className="acuerdo-recuadro-texto-button">No Acepto</p>
                                                                            </div>
                                                                        </div>
                                                                    </button>
                                                                    {!this.state.activebutton1 ?
                                                                        <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>
                                                                        : null}
                                                                </div>
                                                            </div>)
                                                }
                                            </div>
                                            <div className=" col-md-1 col-lg-2 col-xl-1"></div>

                                        </div>
                                    </div>
                                </CenteredWrapper>
                                
                                <Footer />
                                {
                                    this.state.modalPrevAcuerdoGen &&
                                    <Modal isOpen={this.state.modalPrevAcuerdoGen} cerrarModal={this.cerrarModalPrevGen} verBoton={false} >

                                        <p className='text-center title-alumni'><strong>  Firma del acuerdo de uso de datos personales y el acuerdo de uso de medios electrónicos - AlumniESPOL</strong></p>
                                        <p className='text-center input'><input className="form-check-input"
                                            type="checkbox" name="usuarioEscogido"
                                            id="usuarioEscogido" value={"He leído el Acuerdo de uso de datos personales y Acuerdo de uso de medios electrónicos."}
                                                onClick={this.handlerCheckPrev}
                                        />He leído y acepto el Acuerdo de uso de datos personales y Acuerdo de uso de medios electrónicos.</p>
                                            <p className='text-center infor'>Para leer el documento completo dar clic <button className="btn_verAcuerdo_Alumni" onClick={this.cerrarModalPrevGen}>aquí.</button></p>
                                        <div className='button_alumni'  align="center">
                                        <button disabled={!this.state.isvalidbtnAceptar} onClick={this.FirmarAcuerdoAlumni} className=" pb-6">
                                                Aceptar
                                                </button>
                                        </div>
                                    </Modal>
                                }
                                {this.state.modalFirmaManual &&
                                    <ModalXL isOpen={this.state.modalFirmaManual} cerrarModal={this.cerrarModalFirmaM} verBoton={false} textoBoton="" >
                                        <p className='text-center acuerdo-modal-titulo'><strong>FIRMA MANUAL DE ACUERDO DE MEDIOS ELECTRÓNICOS</strong></p>
                                        {/* <p className='text-left acuerdo-modal-subtitulo'><strong>INSTRUCCIONES</strong></p> */}
                                        <p className='text-justify acuerdo-modal-texto' align="justify"  >Estimado, en este caso usted tiene que descargar el archivo del acuerdo de uso de medios electrónicos,
                                            {/*<Renderpdf nombre={this.state.datosUsuario.nombres} apellido={this.state.datosUsuario.apellidos} identificacion={this.state.datosUsuario.identificacion} /> descargarlo,*/}
                                             firmarlo con pluma de color azul, escanearlo y posteriormente adjuntarlo en este mismo formulario.
                                            Adicionalmente, tiene que tomarse una foto enfocando solo su rostro.
                                            Capturar o subir una foto del frente y anverso de su cédula.
                                            En ambos casos, se lo tiene que hacer desde la cámara del dispositivo; para finalizar elegir la opción de enviar.</p>                                        

                                        

                                        <br/>

                                        <div className='row-pasos-manual'>
                                            <div className='paso-manual'>
                                                <h2>1</h2>
                                                <p>Foto del rostro de la persona</p>
                                                
                                                
                                                <div className="paso-icono">
                                                    {this.state.iconGuardRostroExito ?
                                                        
                                                        <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>
                                                        :
                                                        <button onClick={this.abrirModalCamararostro} className="acuerdo-modal-btn">
                                                            <img className="acuerdo-modal-logo" src={rostoimg} alt="Exitoso"></img>
                                                        </button>
                                                    }
                                                </div>
                                            </div>

                                            <div className='paso-manual'>
                                                <h2>2</h2>
                                                <p>Foto de la cédula</p>
                                                <div className="paso-icono">
                                                    {this.state.iconGuardCedulaExito ?
                                                        <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>
                                                        :
                                                        <button onClick={this.abrirModalModoacedula} className="acuerdo-modal-btn"> 
                                                            <img className="acuerdo-modal-logo" src={cedimg} alt="Exitoso"></img>
                                                        </button>
                                                    }
                                                </div>
                                            </div>



                                            <div className="paso-manual">
                                                <h2>3</h2>
                                                {!this.state.IsAcuerdoDescargado ? (
                                                    <>
                                                    <p>Descargar acuerdo para firmarlo manualmente, escanearlo y subirlo</p>
                                                    <div className="paso-icono">
                                                        <button
                                                        onClick={this.descargarAcuerdoFirmaManual}
                                                        className="acuerdo-modal-btn"
                                                        >
                                                        <Renderpdf
                                                            nombre={this.state.datosUsuario.nombres}
                                                            apellido={this.state.datosUsuario.apellidos}
                                                            identificacion={this.state.datosUsuario.identificacion}
                                                            username={this.state.datosUsuario.usuario_sugerido}
                                                            arcb64={this.DataAcuerdo}
                                                            firmadoGeneral={this.state.firmadoGeneral}
                                                            mostrarNombre={this.state.mostrarNombre}
                                                            extraclass="acuerdo-modal-logo"
                                                            posicion="modal"
                                                            style={{
                                                                width: '80px',
                                                                height: '80px'
                                                            }}
                                                        />
                                                        </button>
                                                    </div>
                                                    </>
                                                ) : (
                                                    <>
                                                    <p>Subir acuerdo escaneado con firma manual</p>
                                                    <div className="paso-icono">
                                                        {this.state.iconGuardPdfExito ? (
                                                        <img className="acuerdo-check" src={checkGreen} alt="Exitoso" />
                                                        ) : (
                                                        <button
                                                            onClick={this.abrirModalSubirPdf}
                                                            className="acuerdo-modal-btn"
                                                        >
                                                            <img className="acuerdo-modal-logo" src={subirdoc} alt="Subir" />
                                                        </button>
                                                        )}
                                                    </div>
                                                    </>
                                                )}
                                            </div>

                                        </div>

                                        <br/>

                                                                                                                                                                                                    
                                        <div align="center"  >
                                            <button onClick={this.postCrearCuenta} disabled={this.state.iconGuardCedulaExito && this.state.iconGuardPdfExito && this.state.iconGuardRostroExito && this.state.activebutton ? false : true}
                                                className={this.state.iconGuardCedulaExito && this.state.iconGuardPdfExito && this.state.iconGuardRostroExito && this.state.activebutton ? " modal-modalFM-botones" : "modal-modalFMdisabled-botones"}
                                            >ENVIAR</button>
                                            {!this.state.activebutton ?
                                                <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>

                                                : null}

                                        </div>
                                    </ModalXL>}
                                {'}'}


                                {this.state.modalFirmaManualActualizararch &&
                                    <ModalXL isOpen={this.state.modalFirmaManualActualizararch} cerrarModal={this.cerrarmodalFirmaManualActualizararch} verBoton={false} textoBoton="" >
                                        <p className='text-center acuerdo-modal-titulo'><strong>RECTIFICACIÓN DE DOCUMENTACIÓN DEL ACUERDO DE USO DE MEDIOS ELECTRÓNICOS</strong></p>
                                        <p className='text-left acuerdo-modal-subtitulo'><strong>INSTRUCCIONES</strong></p>
                                        <p className='text-justify acuerdo-modal-texto' align="justify"  >Estimado, en este caso usted tiene que descargar el archivo del acuerdo de uso de medios electrónicos,
                                            {/*<Renderpdf nombre={this.state.datosUsuario.nombres} apellido={this.state.datosUsuario.apellidos} identificacion={this.state.datosUsuario.identificacion} /> descargarlo,*/}
                                             firmarlo con pluma de color azul, escanearlo y posteriormente adjuntarlo en este mismo formulario.
                                            Adicionalmente, tiene que tomarse una foto enfocando solo su rostro.
                                            Capturar una foto del frente y anverso de su cédula.
                                            En ambos casos, se lo tiene que hacer desde la cámara del dispositivo; para finalizar elegir la opción de enviar solicitud.</p>
                                        {!this.props.documentosValidos.isvalidimgpersona &&
                                            <div className="contenedor_foto_rect">
                                                <h3 align="center" className="acuerdo-modal-subtitulo"> <b>Captura de foto rostro de la persona</b></h3>
                                                <div align="center" className="acuerdo-modal-div-logo">
                                                    {this.state.iconGuardRostroExito ?
                                                        <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>
                                                        :
                                                        <button onClick={this.abrirModalCamararostro} className="acuerdo-modal-btn">
                                                            <img className="acuerdo-modal-logo" src={rostoimg} alt="Exitoso"></img>
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {!this.props.documentosValidos.isvalidimgtarjeta &&
                                            <div className="contenedor_cedula_rect">
                                                <h3 align="center " className="text-center  acuerdo-modal-subtitulo"><b>Captura de foto de la cédula</b></h3>
                                                <div align="center" className="acuerdo-modal-div-logo">

                                                    {this.state.iconGuardCedulaExito ?
                                                        <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>
                                                        :
                                                        <button onClick={this.abrirModalModoacedula} className="acuerdo-modal-btn">
                                                            <img className="acuerdo-modal-logo" src={cedimg} alt="Exitoso"></img>
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        }
                                        {!this.props.documentosValidos.isvalidcontrato &&
                                            <div>
                                                {!this.state.IsAcuerdoDescargado ?
                                                    <div className="contenedor_contrato_rect">
                                                        <h3 className='text-center  acuerdo-modal-subtitulo '><b>Descargar acuerdo para firmarlo manualmente, escanearlo y subirlo</b></h3>
                                                        <div align="center " className="acuerdo-modal-div-logo text-center " >
                                                            <button onClick={this.descargarAcuerdoFirmaManual} className="acuerdo-modal-btn">
                                                                <Renderpdf nombre={this.state.datosUsuario.nombres} apellido={this.state.datosUsuario.apellidos}
                                                                    identificacion={this.state.datosUsuario.identificacion} username={this.state.datosUsuario.usuario_sugerido} arcb64={this.DataAcuerdo} firmadoGeneral={this.state.firmadoGeneral} mostrarNombre={this.state.mostrarNombre} extraclass="acuerdo-modal-logo" posicion="modal" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div>
                                                        <h3 className='text-center  acuerdo-modal-subtitulo '><b>Subir acuerdo escaneado con firma manual</b></h3>
                                                        <div align="center " className="acuerdo-modal-div-logo text-center " >
                                                            {this.state.iconGuardPdfExito ?

                                                                <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>
                                                                :
                                                                <button onClick={this.abrirModalSubirPdf} className="acuerdo-modal-btn">
                                                                    <img className="acuerdo-modal-logo" src={subaacfm} alt="Exitoso"></img>
                                                                </button>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                               
                                        <div align="center"  >                               
                                            <button onClick={this.postRectificarDocs} disabled={!((this.props.documentosValidos.isvalidimgtarjeta || this.state.isvalidimgtarjetasub) && (this.props.documentosValidos.isvalidimgpersona || this.state.isvalidimgpersonasub) && (this.props.documentosValidos.isvalidcontrato || this.state.isvalidcontratosub))}
                                                className={((this.props.documentosValidos.isvalidimgtarjeta || this.state.isvalidimgtarjetasub) && (this.props.documentosValidos.isvalidimgpersona || this.state.isvalidimgpersonasub) && (this.props.documentosValidos.isvalidcontrato || this.state.isvalidcontratosub)) ? " modal-modalFM-botones" : "modal-modalFMdisabled-botones"}
                                            >ENVIAR</button>
                                            {!this.state.activebutton ?
                                                <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>

                                                : null}

                                        </div>
                                    </ModalXL>}
                                {'}'}


                                {
                                    this.state.modalFirmaElectronica &&
                                    <ModalXL isOpen={this.state.modalFirmaElectronica} cerrarModal={this.cerrarModalFirmaE} verBoton={false} textoBoton="FIRMAR" >
                                            <p className='text-center acuerdo-modalFE-titulo'><strong>FIRMA ELECTRÓNICA DE ACUERDO DE MEDIOS ELECTRÓNICOS</strong></p>
                                        {/* <p className='text-left acuerdo-modalFE-subtitulo'><strong>INSTRUCCIONES</strong></p> */}
                                        <p className='text-justify acuerdo-modalFE-texto' >Adjuntar el archivo de su firma electrónica e ingresar la contraseña; para finalizar elegir la opción
                                            de Firmar.</p>
                            

                                        <div className='row-pasos-elect'>
                                            <div className='paso-elect'>
                                                <h2>1</h2>
                                                <p>Adjuntar archivo de firma electrónica</p>
                                                <div className='paso-icono'>
                                                    {this.state.iconChooseFirma ?
                                                        <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>                                                            
                                                        :                                                        
                                                        <label>
                                                            <img className="acuerdo-modalFE-logo" src={subirdoc} alt="Exitoso" />
                                                            <input onChange={this.handleFile} hidden id="btnfile" className="vpdf-button" value="" type='file' />
                                                        </label>                                                            
                                                        
                                                    }

                                                </div>

                                            </div>

                                            <div className='paso-elect'>
                                                <h2>2</h2>
                                                <p>Ingresar contraseña de firma electrónica</p>
                                                <div className='paso-elect-icono'>
                                                    <div className="form-group">
                                                        <div className="input-group">
                                                            <input
                                                                type={this.state.showPassword ? "text" : "password"}
                                                                className="form-control"
                                                                data-toggle="password"
                                                                name="contrasena"
                                                                onChange={this.handlerPassword}
                                                                placeholder="Contraseña"
                                                            />
                                                            <button onClick={this.mostrarContrasena} className="input-group-text pb-6">
                                                                {this.state.showPassword ? <FontAwesomeIcon icon={faEye}></FontAwesomeIcon> : <FontAwesomeIcon icon={faEyeSlash}></FontAwesomeIcon>}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                        <div align="center"  >
                                            <button onClick={this.postFirmarAcuerdoElectronicamente} 
                                            disabled={this.state.actFirmaElecInter && this.state.activebutton ? false : true}
                                                className={this.state.actFirmaElecInter && this.state.activebutton ? "modal-modalFE-botones" : "modal-modalFEdisabled-botones"}
                                            >FIRMAR</button>
                                            {!this.state.activebutton ?
                                                <span className="spinner-border spinner-border-sm text-primary ms-1" role="status" aria-hidden="true"></span>

                                                : null}
                                        </div>

                                    </ModalXL>}
                                {'}'}

                                {
                                    this.state.modalCamararostro &&
                                    <Modal isOpen={this.state.modalCamararostro} cerrarModal={this.cerrarModalCamararostro} verBoton={false} >
                                        {/*El número de identificación es para crear el rostro */}
                                            <Camara /*useEffect={this.props.useEffect}*/ imgRostro={this.Dataimgrostro} rostro={true} identificacion={this.state.datosUsuario.identificacion} />
                                    </Modal>
                                }

                                {
                                    this.state.modalCamaracedula &&
                                    <Modal isOpen={this.state.modalCamaracedula} cerrarModal={this.cerrarModalCamaracedula} verBoton={false} >
                                            <Camara /*useEffect={this.props.useEffect}*/ imgRostro={this.Dataimgcedula} rostro={false} identificacion={this.state.datosUsuario.identificacion} />

                                    </Modal>
                                }
                                {
                                    this.state.modalModocedula &&
                                    <Modal isOpen={this.state.modalModocedula} cerrarModal={this.cerrarModalModocedula} verBoton={false} >
                                        <div className='documento-identidad'>
                                            <p className='text-center acuerdo-modalFME-titulo'><strong>Subir documento de identidad</strong></p>

                                            <br/>
                                            <div className="col-10">
                                                <NotificacionTip mensaje="Seleccione el método para subir el documento de identidad" />
                                            </div>
                                            <br/>

                                            <div class="row-opciones-documento" >
                                                <div class="col-10">
                                                    {/* <h3 align="center" className="acuerdo-modal-subtitulo"> <b>Cámara</b></h3> */}
                                                    {/* <button onClick={this.abrirModalCamaracedula} className="acuerdo-modal-btn">
                                                        <img className="acuerdo-modal-logo" src={camaraNecesaria} alt="Exitoso"></img>
                                                    </button> */}

                                                    <button onClick={this.abrirModalCamaracedula} className="identidad-camara-button">
                                                        <div className="row" style={{justifyContent: 'center'}} >
                                                            {/* <div className=" col-2 col-md-2 col-xl-2">
                                                                <img className="acuerdo-logopFE" src={subaacfe} alt="crearcuenta" />

                                                            </div> */}
                                                            <div className=" col-10 col-md-10 col-xl-10">
                                                                <p className="acuerdo-recuadro-texto-button">Cámara</p>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    
                                                </div>
                                                <div class="col-10">
                                                    {/* <h3 align="center" className="acuerdo-modal-subtitulo"> <b>Subir PDF</b></h3> */}
                                                    <button onClick={this.abrirmodalarchivocedula} className="identidad-documento-button">
                                                        <div className="row" style={{justifyContent: 'center'}} >
                                                            {/* <div className=" col-2 col-md-2 col-xl-2">
                                                                <img className="acuerdo-logopFE" src={subaacfe} alt="crearcuenta" />

                                                            </div> */}
                                                            <div className=" col-10 col-md-10 col-xl-10">
                                                                <p className="acuerdo-recuadro-texto-button">Subir PDF</p>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>                                                                                                                        
                                       
                                            {/*<Camara imgRostro={this.Dataimgcedula} rostro={false} identificacion={this.state.datosUsuario.identificacion} />*/}
                                            {/*<Visualizarpdf choosepdf={this.filechoose} />*/}
                                    </Modal>
                                }

                                {
                                    this.state.modalfotocedula &&
                                    <Modal isOpen={this.state.modalfotocedula} cerrarModal={this.cerrarmodalfotocedula} verBoton={false} >
                                        <Camara /*useEffect={this.props.useEffect}*/ imgRostro={this.Dataimgcedula} rostro={false} identificacion={this.state.datosUsuario.identificacion} />
                                    </Modal>
                                }
                                {
                                    this.state.modalarchivocedula &&
                                    <ModalXL modalXXL={true} isOpen={this.state.modalSubirPdf} cerrarModal={this.cerrarModalSubirPdf} verBoton={false} >
                                        <Visualizarpdf choosepdf={this.filechooseCedula} />
                                    </ModalXL>
                                }

                                {
                                    this.state.modalSubirPdf &&
                                    <ModalXL modalXXL={true} isOpen={this.state.modalSubirPdf} cerrarModal={this.cerrarModalSubirPdf} verBoton={false} >
                                      <Visualizarpdf titulo={"ACUERDO FIRMADO"} choosepdf={this.filechoose} />
                                    </ModalXL>
                                }

                                {
                                    this.state.modalFElectricaExitosa &&
                                    <Modal isOpen={this.state.modalFElectricaExitosa} cerrarModal={this.cerrarModalFElectronicaExitosa} verBoton={false} textoBoton="SIGUIENTE" >
                                        <p className='text-center acuerdo-modalFME-titulo'><strong>SOLICITUD DE CREACIÓN DE CUENTA </strong></p>
                                        <div className='mb-3'>
                                            <img className="acuerdo-check " src={check} alt="Exitoso"></img>
                                        </div>

                                        {/*<p className='text-center acuerdo-modalFME-texto'><strong>En aproximadamente 1 hora usted podrá acceder a los beneficios de su nueva cuenta electronica,*/}
                                        {/*    como el uso de la plataformas Office365, correo electrónico, acceso a la red inalámbrica y sistemas.</strong></p>*/}
                                        <p className='text-center acuerdo-modalFME-texto'><strong>Su solicitud de creación de cuenta electronica ha sido recibida exitosamente.</strong></p>
                                        {/*<p className='text-center acuerdo-modalFME-texto'><i>Tu cuenta de correo electrónico estará habilitada en 60 minutos.</i></p>*/}
                                        <div align="center" >
                                            <button className="modal-modalFE-botones" onClick={this.cerrarModalFElectronicaExitosa}  >ACEPTAR</button>
                                        </div>
                                    </Modal>
                                }

                                {this.state.modalError.show &&
                                    <Modal isOpen={this.state.modalError.show} cerrarModal={this.cerrarModalError} verBoton={true} textoBoton="ACEPTAR" >
                                        <p className='text-center'><strong>{this.state.modalError.titulo}</strong></p>
                                        <div align="center">
                                            <img className="registroContra-check" src={this.state.modalError.imagen} alt="Exitoso"></img>
                                        </div>
                                        <p className='text-center'>{this.state.modalError.mensaje}</p>
                                    </Modal>
                                }
                                {this.state.modalErrorAcuerdoGen.show &&
                                    <Modal isOpen={this.state.modalErrorAcuerdoGen.show} cerrarModal={this.cerrarModalErrorGen} verBoton={true} textoBoton="ACEPTAR" >
                                        <p className='text-center'><strong>{this.state.modalErrorAcuerdoGen.titulo}</strong></p>
                                        <div align="center">
                                            <img className="registroContra-check" src={this.state.modalErrorAcuerdoGen.imagen} alt="Exitoso"></img>
                                        </div>
                                        <p className='text-center'>{this.state.modalErrorAcuerdoGen.mensaje}</p>
                                    </Modal>
                                }

                                {
                                    this.state.modalFManualExitosa &&
                                    <Modal isOpen={this.state.modalFManualExitosa} cerrarModal={this.cerrarModalFManualExitosa} verBoton={false} textoBoton="SIGUIENTE" >
                                        <p className='text-center acuerdo-modalFME-titulo'><strong>SOLICITUD DE CREACIÓN DE CUENTA </strong></p>
                                        <div className=' mb-3'>
                                            <img className="acuerdo-check " src={check} alt="Exitoso"></img>
                                        </div>

                                        {/*<p className='text-center acuerdo-modalFME-texto'>Su solicitud de creación de cuenta ha sido enviada*/}
                                        {/*    exitosamente, en un lapso de 24 horas será revisada.</p>*/}
                                        <p className='text-center acuerdo-modalFME-texto'><strong>Su solicitud de creación de cuenta electronica ha sido recibida exitosamente. </strong></p>

                                        <div align="center" >
                                            <button onClick={this.cerrarModalFManualExitosa} className="modal-modalFM-botones" >ACEPTAR</button>
                                        </div>
                                    </Modal>
                                }
                                {
                                    this.state.modalFManualExitosaTipoA &&
                                    <Modal isOpen={this.state.modalFManualExitosaTipoA} cerrarModal={this.cerrarModalFManualExitosaTipoA} verBoton={false} textoBoton="SIGUIENTE" >
                                        <p className='text-center acuerdo-modalFME-titulo'><strong>SOLICITUD DE CREACIÓN DE CUENTA AUTOMATICA USER TIPO A</strong></p>
                                        <div className=' mb-3'>
                                            <img className="acuerdo-check " src={check} alt="Exitoso"></img>
                                        </div>

                                        {/*<p className='text-center acuerdo-modalFME-texto'>Su solicitud de creación de cuenta ha sido enviada*/}
                                        {/*    exitosamente, en un lapso de 24 horas será revisada.</p>*/}
                                        <p className='text-center acuerdo-modalFME-texto'><strong>Su solicitud de creación de cuenta electronica ha sido recibida exitosamente. </strong></p>

                                        <div align="center" >
                                            <button onClick={this.cerrarModalFManualExitosa} className="modal-modalFM-botones" >ACEPTAR</button>
                                        </div>
                                    </Modal>
                                }

                                {
                                    this.state.modalNoAcepACGeneral &&
                                    <Modal isOpen={this.state.modalNoAcepACGeneral} cerrarModal={this.cerrarModalNoAcepACGeneral} verBoton={true} textoBoton="CERRAR">
                                        <p className='text-center acuerdo-modalFME-titulo'><strong>ACUERDO NO ACEPTADO</strong></p>
                                        <div className=' mb-3'>
                                            <img className="acuerdo-check " src={alerta} alt="Exitoso"></img>
                                        </div>
                                            <p className='text-center acuerdo-modalFME-texto'>Estimado, si usted tiene dudas respecto a la aceptación del acuerdo de uso de datos personales y medios electrónicos para el almacenamiento y uso de información registrada en los sistemas informáticos de la ESPOL, ponemos a su disposición el correo de consulta <a href="mailto:datospersonales@espol.edu.ec" target="_blank">datospersonales@espol.edu.ec</a> con el proposito de aclararle sus inquietudes.</p>

                                    </Modal>
                                }
                                {
                                    this.state.modalNoAcepACGeneralprev &&
                                    <Modal isOpen={this.state.modalNoAcepACGeneralprev} cerrarModal={this.cerrarModalNoAcepACGeneralPrev} verBoton={false} >
                                        <p className='text-center acuerdo-modalFME-titulo'><strong>¿Está seguro que no desea aceptar el acuerdo?</strong></p>
                                        <div className=' mb-3'>
                                            <img className="acuerdo-check " src={alerta} alt="Exitoso"></img>
                                        </div>
                                            <p className='text-center acuerdo-modalFME-texto'>Si usted <strong>no acepta</strong> el acuerdo de uso de datos personales y medios electrónicos, no podrá acceder a los sistemas de la ESPOL.</p>
                                        <div align="center" >
                                            <button onClick={this.cerrarModalNoAcepACGeneralPrev} className="modal-modalFM-botones ver-acuerdo" >Ver acuerdo</button>
                                            <button onClick={this.abrirModalNoAcepACGeneral} className="modal-modalFM-botones no-firmar" >No firmar</button>
                                        </div>
                                    </Modal>
                                }

                                {
                                    this.state.modalFirmaGeneralExitosa &&
                                    <Modal isOpen={this.state.modalFirmaGeneralExitosa} cerrarModal={this.cerrarModalFirmaGeneralExitosa} verBoton={true} textoBoton="ACEPTAR" >
                                        <p className='text-center acuerdo-modalFME-titulo'><strong>ACUERDO ACEPTADO</strong></p>
                                        <div className=' mb-3'>
                                            <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>
                                        </div>
                                            <p className='text-center acuerdo-modalFME-texto'><strong>Usted aceptó con éxito el acuerdo de uso de datos personales y medios electrónicos para el almacenamiento y uso de información registrada en los sistemas informáticos de la ESPOL. </strong></p>
                                    </Modal>
                                }

                                {
                                    this.state.modalActualizaciónDocsExitosa &&
                                    <Modal isOpen={this.state.modalActualizaciónDocsExitosa} cerrarModal={this.cerrarModalActualizaciónDocsExitosa} verBoton={false} textoBoton="SIGUIENTE" >
                                        <p className='text-center acuerdo-modalFME-titulo'><strong>Documentos actualizados correctamente </strong></p>
                                        <div className=' mb-3'>
                                            <img className="acuerdo-check " src={checkGreen} alt="Exitoso"></img>
                                        </div>

                                        {/*<p className='text-center acuerdo-modalFME-texto'>Su solicitud de creación de cuenta ha sido enviada*/}
                                        {/*    exitosamente, en un lapso de 24 horas será revisada.</p>*/}
                                        <p className='text-center acuerdo-modalFME-texto'><strong>Se actualizaron los documentos de su solicitud de creación de cuenta electrónica. </strong></p>
                                        <p className='text-center acuerdo-modalFME-texto'><strong>Se notificará por correo el estado de su solicitud. </strong></p>

                                        <div align="center" >
                                                <button onClick={this.cerrarModalActualizaciónDocsExitosa} className="modal-modalFM-botones" >ACEPTAR</button>
                                        </div>
                                    </Modal>
                                }
                            </div>
                        )

                )
        )
    }
}

export default Acuerdo
